export default "__VITE_ASSET__5ab0a2dc__"